import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import LeadSourceEnum from "@/enums/LeadSourceEnum";

  interface Props {
    isOpen: boolean;
    currentSource?: string;
  }

  interface Emits {
    (e: "close"): void;
    (e: "confirm", source: string): void;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SourceModal',
  props: {
    isOpen: { type: Boolean },
    currentSource: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const selectedSource = ref<string>("");

  const selectSource = (source: string) => {
    if (source !== props.currentSource) {
      selectedSource.value = source;
    }
  };

  const confirmSource = () => {
    if (selectedSource.value) {
      emit("confirm", selectedSource.value);
    }
  };

  const closeModal = () => {
    selectedSource.value = "";
    emit("close");
  };

  // Reset selected source when modal opens/closes
  watch(
    () => props.isOpen,
    (isOpen) => {
      if (!isOpen) {
        selectedSource.value = "";
      }
    }
  );

const __returned__ = { props, emit, selectedSource, selectSource, confirmSource, closeModal, ref, watch, get LeadSourceEnum() { return LeadSourceEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})